import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  appBar: {
    position: 'relative'
  },
  appBarWrapper: {
    width: "80%",
    margin: '0 auto'
  }
}));